<template>
  <div v-title="$route.meta.title">
    <div class="page-heading"
         style="position:relative;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/user-order-stat/table">条件搜索添加标签列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <template slot="header">{{ $route.meta.title }}</template>
    <el-table :data="table"
              stripe
              highlight-current-row
              :show-header="false"
              class="margin b15"
              style="width: 100%">
      <el-table-column width="180">
        <template slot-scope="scope">
          <b>{{ scope.row.label }}</b>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <div class="content-wrapper">
            <div :class="scope.row.expanded ? 'content-full' : 'content-clamped'">
              {{ scope.row.value }}
            </div>
            <el-button type="text"
                       size="small"
                       v-if="!!scope.row.allowToggle"
                       @click="toggleContent(scope.$index)"
                       class="toggle-btn">
              {{ scope.row.expanded ? '收起' : '展开' }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import userOrderStatMixins from '../userOrderStat.mixins'

export default {
  data () {
    return {
      id: null,
      table: [],
      newDetailFields: [],
    }
  },
  mixins: [userOrderStatMixins],
  created () {
    this.id = this.$route.params.userid
    this.id > 0 && this.setDetailData(this.id)
  },
  computed: {
    ...Vuex.mapState({
      orderOptions: state => state.order.options,
      userOptions: state => state.users.options,
      userOrderStat: state => state.userOrderStat,
    }),
  },
  methods: {
    async setDetailData (id) {
      await request.common('getUserOderStatDetailApi', {id}).then(({data}) => {
        const usertype = this.userOptions.type.find(it => it.value + '' === data.usertype + '')
        data.usertype = _.get(usertype, 'label', data.usertype)
        data.task_types = data.task_types.join(' , ')
        data.tags = data.tags.join(' , ')
        data.tag_groups = data.tag_groups.join(' , ')
        data.current_location = data.current_location.join(' - ')
        data.id_card_location = data.id_card_location.join(' - ')
        data.all_approved_rate = this.multiplyBy100(_.get(data, 'order_measurement.all.approved_rate', 0), 2, '%')
        data.order_canceled_avg = this.multiplyBy100(_.get(data, 'order_canceled_avg', 0), 2, '%')
        data.all_approved_cnt = _.get(data, 'order_measurement.all.approved_cnt', 0)
        data.evidence_types = data.evidence_types.map(it => this.userOrderStat.evidenceTypeMap[it]).join(' , ')
        data.customer_ids = data.customer_ids.join(' , ')
        data.order_covered_nonsubmitted_locations = data.order_covered_nonsubmitted_locations.map(it => it.join('-')).join('， ')
        data.order_covered_rejected_locations = data.order_covered_rejected_locations.map(it => it.join('-')).join('， ')
        data.order_covered_approved_locations = data.order_covered_approved_locations.map(it => it.join('-')).join('， ')
        data.last_active_tp = data.last_active_tp === '1970-01-01 00:00:00' ? '-' : data.last_active_tp
        data.order_rank_info = { '平均分': data.order_rank_avg, '总得分': data.order_rank_total, '已评分工单数': data.order_rank_cnt }

        for (const taskTypeId in data.order_measurement) {
          if (data.order_measurement.hasOwnProperty(taskTypeId)) {
            data[`order_measurement_${taskTypeId}_approved_rate`] = {
              '审单通过工单数量': data.order_measurement[taskTypeId].approved_cnt,
              '工单审核次数': data.order_measurement[taskTypeId].reviewed_times,
              '准确率': this.multiplyBy100(data.order_measurement[taskTypeId].approved_rate, 2, '%')
            }
          }
        }

        const newDetailFields = _.cloneDeep(this.detailFields)
        this.orderOptions.type.forEach(it => {
          const newPropStr = `order_measurement_${it.value}_approved_rate`
          if (data.hasOwnProperty(newPropStr)) {
            const labelStr = it.label + (it.deprecated ? '(已禁用)' : '')
            newDetailFields.push({
              prop: newPropStr,
              label: `${labelStr} 类任务做单数据`
            })
          }
        })

        newDetailFields.forEach(({prop, label, formatter, allowToggle}) => {
          this.table.push({
            prop,
            label,
            allowToggle,
            value: formatter ? formatter(data) : _.get(data, prop, ''),
            expanded: false,
          })
        })
      })
    },
    multiplyBy100 (num, digit = 2, suffix = '') {
      const str = (num * 100).toFixed(digit)
      return Number(str) + suffix
    },
    toggleContent (index) {
      this.table[index].expanded = !this.table[index].expanded
    }
  },
}
</script>

<style scoped
       lang="scss">
.content-wrapper {
  position: relative;
}

.content-clamped {
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 控制显示的行数 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5; /* 行高，可根据需要调整 */
}

.content-full {
  line-height: 1.5;
}

.toggle-btn {
  margin-top: 5px;
  padding: 0;
  color: #409EFF; /* 蓝色，与Element UI主题一致 */
}
</style>



// WEBPACK FOOTER //
// src/views/user-order-stat/pages/UserOrderStatDetail.vue